import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { AuthProvider } from "./context/AuthContext.tsx";
import { SnackbarProvider } from "notistack";
import { CurrencyProvider } from "./context/Currency.tsx";
import { VideoProvider } from "./context/VideoContext.tsx";
import * as Sentry from "@sentry/react";
import './safe-remove-child';
import './google-translate-cleaner';

Sentry.init({
  dsn: "https://7d2c5f9ca1924514fe3cd17b1d1a6c09@o4509985313193984.ingest.us.sentry.io/4509985391378432",
  sendDefaultPii: true
});

createRoot(document.getElementById("root")!).render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <StrictMode>
      <CurrencyProvider>
        <AuthProvider>
          <VideoProvider>
            <App />
          </VideoProvider>
        </AuthProvider>
      </CurrencyProvider>
    </StrictMode>
  </SnackbarProvider>
);
